import { SIGNING_FLOW_RESUME_ROUTES, SIGNING_FLOW_START_ROUTE, } from '../constants';
/** Maps a signing-flow status onto the route the customer resumes at, falling back to the first step. */
function getSigningFlowResumeRoute(signingFlowStatus) {
    return ((signingFlowStatus && SIGNING_FLOW_RESUME_ROUTES[signingFlowStatus]) ||
        SIGNING_FLOW_START_ROUTE);
}
export default getSigningFlowResumeRoute;
